import type { ReactNode } from "react";
import type { ResolutionEvent } from "../../domain/types/index.js";

const STAMP_LABEL: Partial<Record<ResolutionEvent["kind"], string>> = {
  success: "PJ成功",
  failure: "PJ失敗",
  gameover: "組織崩壊",
};

export function ResultStamp({
  kind,
  message,
  action,
}: {
  kind: ResolutionEvent["kind"];
  message?: string;
  action?: ReactNode;
}) {
  const label = STAMP_LABEL[kind];
  if (!label) return null;
  return (
    <div className={`result-overlay is-${kind}`} aria-live="assertive">
      <div className="result-stamp">{label}</div>
      {kind === "gameover" && message ? <p>{message}</p> : null}
      {action}
    </div>
  );
}
